export default "__VITE_ASSET__Ds7ztH_E__"